import React, { Component } from 'react';
import { NavBar, Button, Icon } from 'antd-mobile';
import NavBarComponent from '../../component/common/NavBarComponent'
import { parseSearchToState } from '../../util/util'
import store from 'store'
import './pay.scss'

class PaySuccess extends Component {
  constructor(props){
    super(props);
    this.param = parseSearchToState(this.props.location.search) || {};
    store.remove('serialNo')
  }

  goHome() {
    this.props.history.replace('/')
  }
  goDetail() {
    this.param.orderNo ? this.props.history.replace(`/routeOrder?orderNo=${this.param.orderNo || ''}`) : this.props.history.replace('/?page=routeOrderList')
  }
  render() {
    return <div className='page' id='paysuccess'>
      <NavBarComponent>
        <NavBar  
          icon={<Icon type="left" color='#333' />} 
          onLeftClick={() => {this.props.history.push('/')}} 
          mode='light'>支付成功</NavBar>
      </NavBarComponent>
      <div className='p_head'>
      <i className='iconfont icon-order'></i>
      <p className='c9 font12 mt10'>支付成功</p>
      {(this.param.price || this.param.total_amount) && <h3 className='c3 font13 mt10'>订单金额：￥{this.param.price || this.param.total_amount}</h3>}
      <div className='p_btn'>
        <Button onClick={()=>this.goHome()} className='btn' size='small'>返回首页</Button>
        <Button onClick={()=>this.goDetail()} className='btn2' size='small'>查看行程</Button>
      </div>
      </div>

    </div>
  }
}

export default PaySuccess;